import type { WindowsCursorFile } from "../api/WindowsCursorsApi.types"

// Revoked later, not right away: the browser reads the URL after the click task has finished.
const REVOKE_DELAY_MS = 10_000

export const saveFile = ({ blob, filename }: WindowsCursorFile) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  document.body.append(link)
  link.click()
  link.remove()
  window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS)
}
